enum GameScreen {
    LOADING = 'LOADING',
    TITLE = 'TITLE',
    CATCHER = 'CATCHER',
    FRYING = 'FRYING',
    RESULT = 'RESULT',
}

export default GameScreen
